import React from 'react';

function LinkButtonCell(props) {
    const buttonStyles = {
        paddingLeft: '5px',
        paddingRight: '5px',
    }
    return (
        <div className="row__cell">
            <a
               href={props.cellContent}>
                <button style={buttonStyles}>Посмотреть</button>
            </a>
        </div>
    );
}

export default LinkButtonCell;